import { render, staticRenderFns } from "./stuMajor.vue?vue&type=template&id=42a5b5a3"
import script from "./stuMajor.vue?vue&type=script&lang=js"
export * from "./stuMajor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports